/** Where a person reports a failure that is on Domino's side (28/10/2026: Benoit). */
export const DOMINO_SUPPORT_EMAIL = 'benoit@dominoflow.com';

/**
 * Prefilled e-mail for a failure the person cannot fix: the run id and the page
 * let us find the run without asking them anything.
 */
export const buildSupportMailto = (params: { subject: string; executionId?: string | null }): string => {
  const body = [
    'Bonjour,',
    '',
    'Un lancement s’est arrêté sans aboutir.',
    params.executionId ? `Lancement : ${params.executionId}` : null,
    `Page : ${window.location.href}`,
  ].filter((line): line is string => line !== null).join('\n');
  return `mailto:${DOMINO_SUPPORT_EMAIL}?subject=${encodeURIComponent(params.subject)}&body=${encodeURIComponent(body)}`;
};
